import React from 'react';

export const usePersistentState = (key, initialValue) => {
	const [state, setState] = React.useState(() => {
		const storedValue = localStorage.getItem(key);
		return storedValue ? JSON.parse(storedValue) : initialValue;
	});

	React.useEffect(() => {
		localStorage.setItem(key, JSON.stringify(state));
	}, [key, state]);

	const clearState = () => {
		localStorage.removeItem(key);
		setState(initialValue);
	};

	return [state, setState, clearState];
};
